import {WorkforceProfileAnalysisDataInput} from '../../types/WorkforceProfileTypes';

export const getAnalysisInputItemCount = (data: WorkforceProfileAnalysisDataInput): number =>
  data.skillsCompetencies.length +
  data.knowledgeSkills.length +
  data.workExperiences.length +
  data.languages.length +
  data.certifications.length +
  data.gapsOrAmbiguities.length +
  (data.candidateProfile ? 1 : 0);
